export const RECEIVE_CTO_COLOR = 'RECEIVE_CTO_COLOR';

export const setCTOConfiguration = (sku, config) => ({
	type: RECEIVE_CTO_COLOR,
	sku,
    config
});


export const setColor = (sku, config) => (dispatch, getState) => {
    return dispatch(setCTOConfiguration(sku, config));
};
